import React, { useState } from "react";
import { ChevronDown, ChevronUp, AlertTriangle, CheckCircle } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };
const SERIF = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

const FREQ_CONFIG = {
  tres_frequent: { label: "Très fréquent", bg: "bg-red-50", text: "text-red-700", border: "border-red-200", dot: "bg-red-500" },
  frequent:      { label: "Fréquent",      bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", dot: "bg-amber-500" },
  rare:          { label: "Rare",           bg: "bg-slate-50", text: "text-slate-600", border: "border-slate-200", dot: "bg-slate-400" },
};

export function ScamCard({ arnaque, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const freq = FREQ_CONFIG[arnaque.frequence] || FREQ_CONFIG.frequent;

  return (
    <div
      className="border border-[#DCD4C6] rounded-sm overflow-hidden"
      data-testid={`scam-card-${arnaque.id}`}
    >
      {/* Header */}
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-3 px-4 py-3 bg-[#F9F6F0] hover:bg-[#F1EBE1] transition-colors text-left"
        aria-expanded={open}
      >
        <span className="text-xl flex-shrink-0" aria-hidden="true">{arnaque.icone}</span>
        <div className="flex-1 min-w-0">
          <p
            className="text-sm font-semibold text-[#2B2623] leading-snug"
            style={{ ...SERIF, fontWeight: 600 }}
          >
            {arnaque.titre}
          </p>
          <div className="flex items-center gap-2 mt-1 flex-wrap">
            <span
              className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-sm border ${freq.bg} ${freq.text} ${freq.border}`}
              style={LORA}
            >
              <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${freq.dot}`} />
              {freq.label}
            </span>
            {arnaque.cout_moyen_si_piege > 0 && (
              <span className="text-xs text-[#9A8F86]" style={LORA}>
                ~{arnaque.cout_moyen_si_piege} €
              </span>
            )}
          </div>
        </div>
        <div className="flex-shrink-0 text-[#9A8F86]">
          {open ? (
            <ChevronUp size={14} strokeWidth={1.5} />
          ) : (
            <ChevronDown size={14} strokeWidth={1.5} />
          )}
        </div>
      </button>

      {/* Body */}
      {open && (
        <div className="px-4 py-3 space-y-3 bg-white/40 border-t border-[#DCD4C6]">
          {/* Scénario */}
          <div>
            <p
              className="text-xs uppercase tracking-widest text-[#8B5E34] mb-1"
              style={LORA}
            >
              Scénario
            </p>
            <p className="text-sm text-[#5C554E] leading-relaxed" style={LORA}>
              {arnaque.scenario}
            </p>
          </div>

          {/* Signal d'alerte */}
          <div className="bg-amber-50 border border-amber-100 p-3 rounded-sm">
            <p
              className="text-xs font-medium text-amber-800 mb-1 flex items-center gap-1.5"
              style={LORA}
            >
              <AlertTriangle size={11} strokeWidth={1.5} className="flex-shrink-0" />
              Signal d'alerte
            </p>
            <p className="text-sm text-amber-900 leading-relaxed" style={LORA}>
              {arnaque.signal_alerte}
            </p>
          </div>

          {/* Réponse recommandée */}
          <div className="bg-emerald-50 border border-emerald-100 p-3 rounded-sm">
            <p
              className="text-xs font-medium text-emerald-800 mb-1 flex items-center gap-1.5"
              style={LORA}
            >
              <CheckCircle size={11} strokeWidth={1.5} className="flex-shrink-0" />
              Réponse recommandée
            </p>
            <p className="text-sm text-emerald-900 leading-relaxed italic" style={LORA}>
              {arnaque.reponse_recommandee}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
